import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";

export const STFormContentWrapper = styled.div`
  && {
    max-width: 500px;

    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
    }

    ${theme.breakpoints.up("sm")} {
      min-width: 360px;
    }
  }
`;

export const CSTFormWrapper = styled(STFormWrapper)`
   min-height: 150px;
`;